import logo from './logo.svg';
import './App.css';
import SimpleLoader from './SimpleLoader';

function App() {
  return (
    <>
      <div className='mainSimpleLoader'>
        <SimpleLoader />
      </div>
    </>
  );
}

export default App;
